import React, { useRef, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  CSVExport
} from "react-bootstrap-table2-toolkit";
import { Col, Row, Button, Input } from "reactstrap";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { Link } from "react-router-dom";
import SubUserFilter from "./subUserFilter";

import { StateContext } from "../utils/context";

import { useTranslation } from "react-i18next";

const LabelsTable = ({ 
    setToggleModal, 
    setDataModal, 
    forceUpdate, 
    setForce,
    data, 
    searchQuery, 
    defaultSorted, 
    subUserData 
  }) => {

  const { currentUser } = useContext(StateContext);
  const { ExportCSVButton } = CSVExport;

  const { t, i18n } = useTranslation();

  const didEff = useRef(false);

  useEffect(() => {
    if (!didEff.current) {
      didEff.current = true;
      return;
    }
    setForce(prev => prev + 1);
  }, [i18n.language]);

  const nameFormatter = (cell, row) => {
    return (
      <div className="flexContainer">
        {(row.logo && row.logo.thumb_small)? (
          <img
            src={row.logo.thumb_small}
            alt={cell}
            width="40"
            height="40"
            className="rounded-circle"
          />
        ): (
            <i className="artist-avatar">{cell.charAt(0).toUpperCase()}</i>
        )}
        <span className="fontWeight700">{cell}</span>
      </div>
    );
  };

  const buttonFormatter = cell => {
    return (
      <>
        {cell ? (
          <div className="btn btn-success btn-status-big disabled">{t("labels.view.table.label.approved")}</div>
        ) : (
          <div className="btn btn-warning btn-status-big disabled">{t("labels.view.table.label.waiting_approval")}</div>
        )}
      </>
    );
  };

  const csvFormatter = cell => (cell ? t("labels.view.table.label.approved") : t("labels.view.table.label.waiting_approval"));
  const actionFormatter = (cell, row) => {
    return (
      <Link className="btn btn-outline-primary" to={`/labels/${row.id}/update/`}>{t("labels.view.table.button.edit")}</Link>
    );
  };
  const columns = [
    {
      dataField: "name",
      text: t("labels.view.table.column.name"),
      formatter: nameFormatter,
      sort: true
    },
    {
      dataField: "owner",
      text: t("labels.view.table.column.owner"),
      sort: true
    },
    {
      //name for search
      dataField: "name",
      hidden: true,
      csvExport: false
    },
    {
      dataField: "company",
      text: t("labels.view.table.column.company"),
      sort: true
    },
    {
      dataField: "contract_received",
      text: t("labels.view.table.column.contract"),
      formatter: buttonFormatter,
      csvFormatter: csvFormatter,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "200px" };
      }
    },
    {
      //data for search
      dataField: "contract_received",
      csvExport: false,
      formatter: csvFormatter,
      hidden: true
    },
    {
      dataField: "information_accepted",
      text: t("labels.view.table.column.info"),
      formatter: buttonFormatter,
      csvFormatter: csvFormatter,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "200px" };
      }
    },
    {
      //data for search
      dataField: "information_accepted",
      formatter: csvFormatter,
      csvExport: false,
      hidden: true
    },
    {
      dataField: "label_approved",
      text: t("labels.view.table.column.status"),
      formatter: buttonFormatter,
      csvFormatter: csvFormatter,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "200px" };
      }
    },
    {
      //data for search
      dataField: "label_approved",
      formatter: csvFormatter,
      csvExport: false,
      hidden: true
    },
    {
      dataField: "action",
      text: t("labels.view.table.column.action"),
      formatter: actionFormatter,
      sort: false,
      csvExport: false,
      headerStyle: (colum, colIndex) => {
        return { width: "111px" };
      }
    }
  ];

  const handleTableChange = (type, { sortField, sortOrder, data }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "name" || sortField === "contract_received" || sortField === "information_accepted" || sortField === "label_approved") {
      searchQuery.setOrdering({order: ascDesc, name: sortField, sort: sortField});
    }
    if (sortField === "company") {
      searchQuery.setOrdering({order: ascDesc, name: "user__company", sort: sortField});
    }
    if(sortField === "owner") {
      searchQuery.setOrdering({order: ascDesc, name: "user__username", sort: "user__username"});
    }
  }

  return (
    <ToolkitProvider
    keyField="id"
    data={data}
    columns={columns}
    search={{
      searchFormatted: true
    }}
    exportCSV={ {
      fileName: 'labels.csv',
    } }
  >
    {props => (
      <div>
        <Row>
          <Col>
            <div className="customSearch">
            <Input placeholder={t("labels.view.table.placeholder.search")} value={searchQuery.query} style={{marginBottom: 10}} onChange={e => searchQuery.setQuery(e.target.value)}/>
            </div>
          </Col>
          {
            currentUser.is_premium_user && <SubUserFilter subUserData={subUserData} />
          }
          <Col>
            <div className="flexEndContainer">
              <ExportCSVButton
                className="btn btn-outline-info"
                {...props.csvProps}
              >
                {t("labels.view.table.button.export_csv")}
              </ExportCSVButton>
            </div>
          </Col>
        </Row>

        <BootstrapTable
          {...props.baseProps}
          bordered={ false }
          remote={ { sort: true } }
          defaultSorted={defaultSorted}
          onTableChange={handleTableChange}
        />
      </div>
    )}
  </ToolkitProvider>
  );
};

export default LabelsTable;
